import { Box, CircularProgress, Typography } from '@mui/material';
import { tokens } from '../../theme';
import type { FullPageProgressProps } from './types';

// The waiting state for anything that blocks the whole app: checking for a
// session, or finishing a login. Deliberately plain — a skeleton of a page we
// might not be allowed to show would be worse than a spinner.
//
// **Not the loading state for content.** A page waiting on the content service
// is inside the shell and keeps its chrome; blanking the whole viewport for it
// would throw away the AppBar and the rail the user can already see.
export const FullPageProgress = ({ label }: FullPageProgressProps) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 4,
    }}
  >
    <CircularProgress aria-hidden />
    {/* role=status so a screen reader announces the wait rather than a silent
        blank page.

        Poppins rather than the body font: this is the only thing on the screen,
        so it is a heading in every sense but the tag. It also keeps the wait
        looking like the login page it usually follows. */}
    <Typography
      role="status"
      color="text.secondary"
      sx={{ fontFamily: tokens.fontFamily.heading }}
    >
      {label}
    </Typography>
  </Box>
);
